// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M5oTX","content":"styles_content__bccXV","row":"styles_row__NFN0t","footer":"styles_footer__9Cc0_","phraseLength":"styles_phraseLength__3HdGN"};